<template xmlns:v-swiper="http://www.w3.org/1999/xhtml">
  <div>
    <div class="main">
      <div class="primarylists">
        <ul class="container">
          <li>
            <div class="titles clear">
              <div class="title l">使用者操作说明</div>
            </div>
            <p style="text-align: right">
              Ver1.00&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2021.04.01
            </p>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
              <div class="secondlists">
        <ul class="container padding-top">
          <li>
            <div class="titles">
              <div class="title l">1.切换语言</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\zh\manual_zh_1.png" />
            <p>
              点击画面上部主菜单栏的国旗图标，在下拉菜单中可以切换显示语言。
            </p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">2.系统登录</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\zh\manual_zh_2.png" />
            <p>①.点击画面上部的主菜单栏中的Login图标，显示账号密码登录画面。</p>
            <p>②.在用户登录弹窗上输入用户名和密码。</p>
            <p>③.点击「立即登录」按钮后系统会自动进行登录处理。</p>
            <p>
              ※在使用初始密码的情况下，登录后强制迁移到密码变更画面，显示提示更改初始密码的警告信息。
            </p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">3.退出系统</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\zh\manual_zh_3.png" />
            <p>
              在登录的状态下，点击画面上部的主菜单栏中的注销图标，就可以从系统中退出。
            </p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">4.查询课程</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\zh\manual_zh_4.png" />
            <p>
              在画面上部的主菜单栏中的检索输入框中输入检索关键字，点击「查询」按钮后，与检索关键字相关的记录会作为检索结果显示。
            </p>
            <p>检索结果的图像如下。</p>
            <img src="../../../static\images\zh\manual_zh_5.png" />
            <p>点击想要学习的课程，跳转到课程详细画面。</p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">5.更改密码</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\zh\manual_zh_6.png" />
            <p>①.点击画面上部主菜单栏中的用户图标，显示用户信息管理画面。</p>
            <p>
              ②.在画面左侧的侧面菜单中点击「更改密码」，在右侧显示更改密码选项卡。
            </p>
            <p>
              ③.在页面右侧输入区域输入「当前密码」「新密码」和「重复密码」并点击「OK」按钮。
            </p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">6.我的课程</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\zh\manual_zh_7.png" />
            <p>点击画面上部的主菜单的「我的课程」图标，跳转到我的课程画面。</p>
            <img src="../../../static\images\zh\manual_zh_8.png" />
            <p>在我的课程画面上，课程会按照上课开始日期的顺序显示。</p>
            <p style="color: red">
              ※主菜单栏的检索对象，不仅仅是我的课程，而是整个系统。
            </p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">7.课程学习</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
          </li>
        </ul>
      </div>
      <div class="thirdlists">
        <ul class="container">
          <li>
            <div class="titles">
              <div class="title l">7.1.选择课程</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\zh\manual_zh_9.png" />
            <p>
              在主页画面或我的课程画面中选择学习对象课程，然后迁移到课程概要画面。
            </p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">7.2.课程概要</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\zh\manual_zh_10.png" />
            <p>
              ①.在课程概要画面中，按下「开始学习」按钮，跳转到课程目录画面。
            </p>
            <img src="../../../static\images\zh\manual_zh_11.png" />
            <img src="../../../static\images\zh\manual_zh_12.png" />
            <p>②.点击课程目录中某节的链接，学习与该节相关的内容。</p>
            <p>③.可以通过「下一个」或「上一个」按钮切换内容。</p>
            <p style="color: red">
              ※如果您浏览了所有课程的内容，课程标记将变为绿色。
            </p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">7.3.章节练习</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\zh\manual_zh_13.png" />
            <p>
              ①.在有小测试的章节中，练习列显示小测试标记。点击小测试标记（红色状态）后，会迁移到小测试画面。
            </p>
            <img src="../../../static\images\zh\manual_zh_14.png" />
            <p>②.确认问题的内容，从选项中选择回答。</p>
            <p>③.按下「提交答案」按钮，提交小测试。</p>
            <img src="../../../static\images\zh\manual_zh_15.png" />
            <p>④.评分结果显示在成绩列。全部答案正确则小测试图标变为绿色。</p>
            <p style="color: red">
              ※小测试不是学习进度和学习成绩的评价对象。即使不实施也可以继续听课。
            </p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">7.4.考试</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\zh\manual_zh_16.png" />
            <p>
              ①.如果按照目录全部学习完内容，则进度率为60%。点击「考试」，进入考试画面。
            </p>
            <img src="../../../static\images\zh\manual_zh_17.png" />
            <p>
              ②.按下「开始考试」按钮，开始最终测试。按下「放弃考试」按钮后，将返回目录画面。
            </p>
            <p style="color: red">
              ※最终考试可以多次参加。以最后一次的成绩判定合格或不合格。
            </p>
            <img src="../../../static\images\zh\manual_zh_18.png" />
            <p>
              ③.可以通过「上一题」或「下一题」按钮切换测试题。按下「提交试卷」按钮后，跳转到答题卡画面。
            </p>
            <img src="../../../static\images\zh\manual_zh_19.png" />
            <p>
              ④.在答题卡画面确认全部问题答案，按下「提交试卷」按钮，考试提交确认框弹出。
            </p>
            <p>⑤.按下「确定」按钮后，将提交回答，考试结束。</p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">7.5.保证书</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\zh\manual_zh_20.png" />
            <p>
              ①.考试合格后，进度率为80%。点击子菜单栏中的「保证书」链接，显示保证书画面。
            </p>
            <img src="../../../static\images\zh\manual_zh_21.png" />
            <p>②.勾选各保证书画面的同意复选框。</p>
            <p>③.按下「提交」按钮，提交保证书。</p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">7.6.问卷调查</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\zh\manual_zh_22.png" />
            <p>
              ①.提交保证书的话，进展率是90%。点击子菜单栏中的「问卷调查」链接，显示问卷调查画面。
            </p>
            <img src="../../../static\images\zh\manual_zh_23.png" />
            <p>②.回答问卷画面上的所有问题。</p>
            <p>③.按下「提交」按钮，提交问卷调查。</p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">7.7.结课申请</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\zh\manual_zh_24.png" />
            <p>①.点击子菜单栏中的「结课申请」链接，显示结课申请画面。</p>
            <p style="color: red">
              ※提交问卷后，进度率为99%，退出申请画面会自动显示。
            </p>
            <img src="../../../static\images\zh\manual_zh_25.png" />
            <p>②.课程的进展状况确认。</p>
            <p>
              ③.问卷调查结束，「申请」按钮活性状态。按下「申请」按钮后，本课程结束。
            </p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">7.8.错题本</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\zh\manual_zh_26.png" />
            <p>
              ①.考试结束后，点击子菜单栏的「错题本」链接，显示错题一览画面。
            </p>
            <img src="../../../static\images\zh\manual_zh_27.png" />
            <p>②.您可以确认所有错误问题的正确答案和分析。</p>
            <p>②.从错误列表中删除：从错误问题列表中删除该问题。</p>
            <p>③.错题导出：将所有错题导出为EXCEL文件。</p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">7.9.查看成绩</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\zh\manual_zh_28.png" />
            <p>
              ①.考试结束后，点击子菜单栏的「成绩分析」链接，显示成绩分析画面。
            </p>
            <img src="../../../static\images\zh\manual_zh_29.png" />
            <p>②.可以参照最终考试的成绩。</p>
            <p>③.点击「考试履历」链接后，会跳转到考试履历画面。</p>
            <img src="../../../static\images\zh\manual_zh_30.png" />
            <p>④.按下「返回」按钮后，将返回成绩分析画面。</p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">7.10.课程笔记・下载笔记</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\zh\manual_zh_31.png" />
            <p>
              ①.点击内容学习画面左侧显示区域的「笔记」选项卡，将显示笔记输入区域。可以记录该章节的内容。
            </p>
            <img src="../../../static\images\zh\manual_zh_32.png" />
            <p>
              ②.点击子菜单栏的「笔记导出」链接，可汇总各章节的笔记并导出为WORD文件。
            </p>
          </li>
        </ul>
      </div>
      <div class="secondlists">
        <ul class="container">
          <li>
            <div class="titles">
              <div class="title l">8.学情分析-学情统计</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\zh\manual_zh_33.png" />
            <p>
              ①.点击画面上部的主菜单栏中的「学情分析」⇒「学情统计」菜单，就可以查看课程的学习进展情况。
            </p>
            <p>②.点击课程名称的标志，跳转到相应的课程详细画面。</p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">9.直播课</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\zh\manual_zh_34.png" />
            <p>
              点击画面上部的主菜单栏上的「直播信息」图标，就可以查看直播信息。
            </p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">10.进度确认（※仅限管理者权限※）</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\zh\manual_zh_35.png" />
            <p>
              ①.在课程概要画面中，按下「进度确认」按钮，迁移到进度确认画面。
            </p>
            <img src="../../../static\images\zh\manual_zh_36.png" />
            <p>②.输入检索条件，按下「查询」按钮，确认查询结果。</p>
            <p>③.按下「导出」按钮，将查询结果作为EXCEL导出。</p>
          </li>
        </ul>
      </div>
          </li>
        </ul>
      </div>
    
    </div>
  </div>
</template>

<script>
//课程页轮播图
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import Element from "element-ui";
//国际化引入
import Vue from "vue";
import { mapMutations } from "vuex";
import { lang } from "../../assets/languages/getLanguageType.js";
Vue.prototype.$lang = lang;

export default {
  activeName: "second",
  name: "index",
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  props: ["userId"],
  data() {
    return {
      userIds: null,
      s1: null,
      s2: null,
      s3: null,
      s4: null,
      s5: null,
      sList: null,
      isMobileFlg: false, //設置課程分類用，手機版，下拉的顯示等
      arrowdownCss: true, //設置課程分類用，手機版，下拉的顯示等
      arrowdownIcon: true, //設置課程分類用，手機版，下拉的顯示等
      heightOut: 0, //設置課程分類用，手機版，下拉的顯示等
      heightIn: 0, //設置課程分類用，手機版，下拉的顯示等
      courseInfo: {},
      currentIndex1: -1,
      currentIndex2: -1,
      tagOne: null,
      tagTwo: null,
      loading: false,
      menuList: null,
      recommendCourse: {},
      itemList: [],
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
        },
        autoplay: {
          delay: 10000,
          disableOnInteraction: false, // 手动切换之后继续自动轮播
        },
        loop: true,
      },
    };
  },
  created() {
    //监听getMenuHeight
    window.addEventListener("resize", this.getMenuHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getMenuHeight);
  },
  mounted() {
    //获取设备屏幕的高度
    // const h = document.body.clientHeight;
    // this.$refs.indexDiv.style.height = h + "px";
    setTimeout(() => {
      const that = this;
      if (that.$refs.heightOut != undefined) {
        that.heightOut = that.$refs.heightOut.offsetHeight;
        that.heightIn = that.$refs.heightIn.offsetHeight;
        // console.log(this.heightOut)
        // console.log(this.heightIn)
        if (that.heightOut < that.heightIn) {
          that.arrowdownIcon = true;
        } else {
          that.arrowdownIcon = false;
        }
      }
    }, 2000);

    this.userIds = window.sessionStorage.getItem("id");
    this.getMenuHeight();
    this.companyId = window.sessionStorage.getItem("companyId");

    //取得首页所有课程
    this.loading = true;
    this.$api
      .post("/home/getHomeCourseInfo", {
        languageType: this.$lang(),
      })
      .then((response) => {
        this.courseInfo = response.data;
        // console.log("首页的所有课程", this.courseInfo);
        this.recommendCourse = this.courseInfo.starCourse.courseList;
        this.menuList = this.courseInfo.starCourse.menuList;
        this.sList = this.courseInfo.frontList;
        if (this.sList != null) {
          for (var k = 0; k < this.sList.length; k++) {
            if (k == 0) {
              this.s1 = this.sList[k].imagePath;
            }
            if (k == 1) {
              this.s2 = this.sList[k].imagePath;
            }
            if (k == 2) {
              this.s3 = this.sList[k].imagePath;
            }
            if (k == 3) {
              this.s4 = this.sList[k].imagePath;
            }
            if (k == 4) {
              this.s5 = this.sList[k].imagePath;
            }
          }
        }
        this.loading = false;
      });

    if (this._isMobile()) {
      this.isMobileFlg = true; //手机端
      this.arrowdownIcon = false;
    } else {
      this.isMobileFlg = false; //pc端
    }
  },
  methods: {
    //移动端：滑动功能，增加css的方式。
    //PC端：显示下拉箭头
    getMenuHeight() {
      const that = this;
      if (that.$refs.heightOut != undefined) {
        that.heightOut = that.$refs.heightOut.offsetHeight;
        that.heightIn = that.$refs.heightIn.offsetHeight;
        // console.log(this.heightOut)
        // console.log(this.heightIn)
        if (that.heightOut < that.heightIn) {
          that.arrowdownIcon = true;
        } else {
          that.arrowdownIcon = false;
        }
      }
    },
    //作用：为primarymenu增加primarymenu-add
    cssedit() {
      this.arrowdownCss = !this.arrowdownCss;
    },

    //作用：判断终端设备
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },

    handleClick(el, a, b) {
      // console.log(el, a, b);
    },
    explore: function () {
      // 用 #explore 添加锚点
      let jump = document.querySelectorAll("#explore");
      let total = jump[0].offsetTop;
      let distance = document.getElementById("app").scrollTop;
      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      let step = total / 50;
      if (total > distance) {
        smoothDown();
      } else {
        let newTotal = distance - total;
        step = newTotal / 50;
        smoothUp();
      }

      function smoothDown() {
        if (distance < total) {
          distance += step;
          document.getElementById("app").scrollTop = distance;
          setTimeout(smoothDown, 10);
        } else {
          document.getElementById("app").scrollTop = total;
        }
      }

      function smoothUp() {
        if (distance > total) {
          distance -= step;
          document.getElementById("app").scrollTopp = distance;
          setTimeout(smoothUp, 10);
        } else {
          document.getElementById("app").scrollTop = total;
        }
      }
    },
    go_regist: function () {
      this.$emit("info", "regist");
    },
    goRouter: function (url, tagOneId) {
      if (tagOneId) {
        this.$router.push({
          path: url,
          query: {
            tagOne: tagOneId,
          },
        });
      } else {
        this.$router.push(url);
      }
    },
    begin_start: function () {
      // console.log(document.getElementById("2"));
      //this.$router.push("/home/personSet");
    },
    ...mapMutations("header", ["setHistory"]),
    go_course: function (item, collegeId) {
      this.userIds = window.sessionStorage.getItem("id");
      if (this.userIds == "" || this.userIds == null) {
        this.$alert(window.vm.$i18n.t("js.PleaseLogin"), "", {
          confirmButtonText: window.vm.$i18n.t("js.confirm"),
        });
        return;
      } else {
        window.sessionStorage.setItem("courseGOBackNum", 1);
        this.setHistory("/home");
        this.$router.push({
          name: "Aicourse",
          query: {
            buyCourseId: item.courseId,
            buyCollegeId: collegeId,
          },
        });
      }
    },

    secondMenuChange: function (index1, id) {
      if (this.tagTwo == id) {
        return;
      }
      this.tagTwo = id;
      let allFlag = 1;
      if (id === -1) {
        //如果二级分类为-1，那就把一级id传给后台
        this.tagTwo = this.courseInfo.courses[index1].id;
        allFlag = 1;
      } else {
        allFlag = 0;
      }
      this.tagOne = this.courseInfo.courses[index1].id;
      this.loading = true;
      this.companyId = window.sessionStorage.getItem("companyId");
      this.$api
        .post("/home/getHomeCourseInfoChild", {
          id: this.tagTwo,
          allFlag: allFlag,
          languageType: this.$lang(),
        })
        .then((response) => {
          // console.log(response.data.courseList)
          this.courseInfo.courses[index1].courseList = response.data.courseList;
          this.loading = false;
        });
    },
    mouseOverUp($event) {
      $event.currentTarget.className = "el-icon-arrow-up oaa";
    },
    mouseLeaveUp($event) {
      $event.currentTarget.className = "el-icon-arrow-up up_laa";
    },
    mouseOverDown($event) {
      $event.currentTarget.className = "el-icon-arrow-down oaa";
    },
    mouseLeaveDown($event) {
      $event.currentTarget.className = "el-icon-arrow-down down_laa";
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {
  padding-top: 60px;
}

a {
  text-decoration: none;
  color: white;
  -webkit-tap-highlight-color: white;
  -webkit-user-select: none;
  -moz-user-focus: none;
  -moz-user-select: none;
}
.l {
  float: left;
}
.r {
  float: right;
}
.clear::after {
  content: ".";
  display: block;
  clear: both;
  height: 0;
  visibility: hidden;
}
.container,
.bigCourse {
  width: 1200px;
  margin: 0 auto;
}

@media screen and (min-width: 1000px) and (max-width: 1200px) {
  .container,
  .bigCourse {
    width: 1000px;
  }
}
@media screen and (min-width: 800px) and (max-width: 1000px) {
  .container,
  .bigCourse {
    width: 800px;
  }
}
@media screen and (min-width: 600px) and (max-width: 800px) {
  .container,
  .bigCourse {
    width: 600px;
  }
}
@media screen and (max-width: 600px) {
  .container,
  .bigCourse {
    width: 400px;
  }
}
.swiper-container {
  margin-bottom: 20px;
  position: relative;
  /* overflow: hidden;
    height: 450px; */
}
.swiper-container img {
  width: 100%;
}

.primarylists {
  padding-top: 10px;
}

.primarylists > ul > li {
  padding-bottom: 20px;
  width: 1210px;
  overflow: hidden;
}
.primarylists ul li .titles {
  height: 35px;
  width: 1000px; /* 需要配合JS动态设置宽度 */
  padding-bottom: 5px;
  color: black;
  margin-bottom: 10px;
  display: flex;
  inline-size: max-content;
}

.secondlists {
  padding-left: 30px;
}
.secondlists > ul > li {
  padding-bottom: 10px;
  overflow: hidden;
}

.secondlists ul li .titles {
  height: 35px;
  width: 1000px; /* 需要配合JS动态设置宽度 */
  padding-bottom: 5px;
  padding-left: 5px;

  color: black;
  margin-bottom: 5px;
  display: flex;
  inline-size: max-content;
}

.secondlists ul li .titles .title {
  font-size: 22px;
  text-decoration: underline;
  line-height: 35px;
  font-weight: bold;
}

.secondlists ul li img {
  height: auto;
  width: 100%;
  margin-top: 10px;
  overflow: hidden;
}

.secondlists ul li p {
  font-size: 14px;
  margin-top: 10px;
}

.thirdlists {
  padding-left: 30px;
}
.thirdlists > ul > li {
  padding-bottom: 10px;
  padding-left: 30px;
  overflow: hidden;
}

.thirdlists ul li .titles {
  height: 35px;
  width: 1000px; /* 需要配合JS动态设置宽度 */
  padding-bottom: 5px;
  padding-left: 5px;
  color: black;
  margin-bottom: 5px;
  display: flex;
  inline-size: max-content;
}

.thirdlists ul li .titles .title {
  font-size: 22px;
  text-decoration: underline;
  line-height: 35px;
  font-weight: bold;
}

.thirdlists ul li img {
  height: auto;
  width: 100%;
  margin-top: 10px;
  overflow: hidden;
}

.thirdlists ul li p {
  font-size: 14px;
  margin-top: 10px;
}

.primarylists ul li .titles img {
  width: 32px;
  height: 32px;
  margin-top: 1px;
}
.primarylists ul li .titles .title {
  font-size: 24px;
  padding: 0 20px 0 10px;
  line-height: 35px;
  font-weight: bold;
}

.primarylists ul li .titles .more {
  font-size: 16px;
  line-height: 35px;
  cursor: pointer;
  padding-right: 20px;
}
.primarylists ul li .titles .more a {
  color: black;
}

.primarylists .secondlist {
  height: 100%;
  font-size: 16px;
}
.primarylists .secondlist ul li {
  float: left;
  padding: 3px 10px;
  cursor: pointer;
  margin-right: 16px;
  background: #666;
  border-radius: 15px;
  color: white;
}
.primarylists .secondlist ul li.choose {
  background: lightskyblue;
}

.primarylists .lessons ul {
  height: 350px;
  overflow: hidden;
  transform: translateX(5px);
}

.primarylists .lessons ul li {
  width: 190px;
  height: 170px;
  float: left;
  box-sizing: border-box;
  background: #333;
  background-clip: padding-box;
  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 10px;
  overflow: hidden;
}
.primarylists .lessons ul li:nth-of-type(1) {
  width: 390px;
  height: 350px;
}
.primarylists .lessons ul li:nth-of-type(1) .img {
  height: 200px;
}
.primarylists .lessons ul li .img {
  height: 100px;
  width: 100%;
  overflow: hidden;
}
.primarylists .lessons ul li .img img {
  width: 100%;
  transition: all 0.25s ease-in-out;
  -moz-transition: all 0.25s ease-in-out;
  -webkit-transition: all 0.25s ease-in-out;
  -o-transition: all 0.25s ease-in-out;
}
.primarylists .lessons .lessontitle {
  padding: 0px 10px;
  margin: 8px 0 3px;
  color: #f8f8f8;
  font-size: 15px;
  cursor: pointer;
  /* 1行溢出隐藏 */
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.primarylists .lessons .lessontitle:hover {
  color: lightskyblue;
}
.primarylists .lessons .introduce {
  padding: 0 10px;
  color: #999;
  font-size: 12px;

  /* 1行溢出隐藏 */
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.primarylists .lessons .islike {
  float: right;
  margin: 2px 10px 3px 0px;
  color: #f8f8f8;
  font-size: 10px;
  cursor: pointer;
  overflow: hidden;
}

.primarylists .lessons .islike span {
  float: right;
}

.primarylists .lessons ul li:nth-of-type(1) .lessontitle {
  font-size: 16px;
  padding: 15px 20px 0 20px;
  /* 2行溢出隐藏 */
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.primarylists .lessons ul li:nth-of-type(1) .introduce {
  font-size: 14px;
  line-height: 24px;
  padding: 10px 20px 0 20px;
  /* 3行溢出隐藏 */
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.footer {
  padding: 50px 0 30px 0;
  color: white;
  text-align: center;
  background: url(../../../static/images/bg/myCourseBackgroundFoot.jpg)
    no-repeat center bottom;
  background-size: cover;
}
.footer .line1 {
  font-size: 46px;
}
.footer .line2 {
  font-size: 14px;
  margin-bottom: 30px;
}
.footer .line3 {
  display: inline-block;
  padding: 5px 50px;
  border: 1px solid white;
  border-radius: 20px;
}
.footer .line3:hover {
  background: white;
  color: black;
  cursor: pointer;
}
.header {
  height: 60px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: #121212;
  color: white;
  z-index: 10;
  opacity: 0.8;
}
.header ul li {
  float: left;
  margin-right: 30px;
}
.header .logo {
  padding-top: 12px;
  cursor: pointer;
}
.header .logo img {
  height: 36px;
}
.header ul li div {
  height: 12px;
  font-size: 12px;
  position: relative;
}
.header ul li:hover div {
  color: #999;
}
.header ul li div span {
  height: 16px;
  width: 16px;
  line-height: 16px;
  text-align: center;
  background: red;
  color: white;
  display: block;
  border-radius: 50%;
  position: absolute;
  bottom: -8px;
  right: -18px;
}
.header ul li p {
  padding-top: 5px;
  font-size: 20px;
  text-align: center;
  color: #409eff;
}

.header .right {
  padding-top: 10px;
}
.header .right .user > div {
  margin-right: 10px;
}
.header .right .user .photo {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
}
.header .right .user .photo img {
  width: 100%;
}
.header .right .user .name,
.header .right .user .logout {
  font-size: 22px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
}
.header .right .user .name:hover,
.header .right .user .logout:hover {
  color: #999;
}

.header .right .search {
  margin: 0 20px;
  font-size: 22px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
}
.header .right .search:hover {
  color: #999;
}
.header .right .flag {
  height: 40px;
  width: 60px;
  cursor: pointer;
  overflow: hidden;
  border-radius: 5px;
}
.header .right .flag img {
  width: 100%;
}
.swiper_bottom_shade {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 10;
  height: 200px;
  width: 100%;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(224, 224, 219, 0)),
    to(#fff)
  );
  background: -webkit-linear-gradient(top, rgba(224, 224, 219, 0), #fff 100%);
  background: linear-gradient(180deg, rgba(224, 224, 219, 0), #fff 100%);
}
.bigCourse {
  position: relative;
}
.bigCourse ul {
  /*background-color: rgba(255,255,255,0.7);*/
  /*border-radius: 10px;*/
  /*padding: 30px 2% 0;*/
  width: 98%;
  margin: 0 1%;
  /*position: absolute;*/
  /*bottom: 10px;*/
  /*z-index: 9;*/
}

.bigCourse li a {
  font-size: 14px;
  background-image: -webkit-linear-gradient(315deg, #02adff 0%, #00d3ff 100%);
  background-image: linear-gradient(135deg, #02adff 0%, #00d3ff 100%);
  padding: 5px 15px;
  border-radius: 5px;
  margin-right: 20px;
  float: left;
  margin-bottom: 10px;
}
.bigCourse li a:hover {
  background-image: -webkit-linear-gradient(315deg, #00d3ff 0%, #02adff 100%);
  background-image: linear-gradient(135deg, #00d3ff 0%, #02adff 100%);
}
.showAllCourse {
  position: absolute;
  right: 10px;
  top: 5px;
  cursor: pointer;
}
.showAllCourse img {
  width: 19px;
}
/* .showAllCourse i{*/
/*  font-size: 20px;*/
/*   font-weight: bold;*/
/*   color: #666;*/
/*}*/
/*.showAllCourse i :hover{*/
/*  color: #02ADFF;*/
/*}*/
.primarymenu-add {
  height: 39px;
  overflow: hidden;
}
.boxout {
}
.boxout .boxin {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
}
.boxout .boxin li.SchoolBusiness_menu_li {
  box-sizing: border-box;
}
::-webkit-scrollbar {
  display: none;
}

.el-tabs >>> .el-tabs__active-bar {
  height: 30px;
  background-color: #02adff;
  border-radius: 25px;
  padding: 0 20px;
  margin-left: -20px;
  margin-bottom: 5px;
}
.el-tabs >>> .el-tabs__item {
  z-index: 2;
}
.el-tabs >>> .el-tabs__nav-wrap:after {
  height: 0px;
  background-color: none;
}
.el-tabs >>> .el-tabs__nav-scroll {
  padding: 0 20px;
}
.el-tabs >>> .el-tabs__item.is-active {
  color: #fff;
}
.el-tabs >>> .toolbar {
  padding-top: 20px;
}
.el-tabs >>> .el-pager {
  margin: 0 10px;
}
.vaa :hover {
  transform: scale(1.05, 1.05);
  cursor: pointer;
}
.down_laa {
  -webkit-text-stroke-width: 2px;
  color: #999;
}
.up_laa {
  -webkit-text-stroke-width: 2px;
  color: #00d3ff;
}
.oaa {
  -webkit-text-stroke-width: 2px;
  color: #ffb821;
}
.target-fix {
  position: relative;
  top: -60px;
  display: block;
  height: 0;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/index/manual_zh.vue